(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bastiafresh-services"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastiafresh-services-quote')) {
    customElements.define('bastiafresh-services-quote', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.choice = this.querySelector('[data-service-choice]');
        this.quoteForm = this.choice?.form;
        if (!this.choice || !this.quoteForm) return;
        this.panels = Array.from(this.querySelectorAll('[data-service-panel]'));
        this.condition = this.querySelector('[name="contact[condition]"]');
        this.choice.addEventListener('change', () => this.updatePanels());
        this.condition?.addEventListener('change', () => this.updateDamageDetails());
        this.querySelectorAll('[data-choose-service]').forEach(link => {
          link.addEventListener('click', () => {
            const option = Array.from(this.choice.options).find(item => item.dataset.service === link.dataset.chooseService);
            if (!option) return;
            this.choice.value = option.value;
            this.updatePanels();
            this.choice.focus({ preventScroll: true });
          });
        });
        this.updatePanels();
      }
      updatePanels() {
        this.activeService = this.choice.selectedOptions[0]?.dataset.service || '';
        this.panels.forEach(panel => {
          const active = panel.dataset.servicePanel.split(' ').includes(this.activeService);
          panel.hidden = !active;
          if (panel.tagName === 'FIELDSET') panel.disabled = !active;
          panel.querySelectorAll('input, select, textarea').forEach(field => {
            field.disabled = !active;
            if (field.hasAttribute('data-required')) field.required = active;
          });
        });
        this.updateDamageDetails();
      }
      updateDamageDetails() {
        const details = this.querySelector('[data-damage-details]');
        if (!details || !this.condition) return;
        const active = !this.condition.disabled && this.condition.selectedOptions[0]?.dataset.optionKey === 'existing';
        details.hidden = !active;
        details.querySelectorAll('textarea').forEach(field => {
          field.disabled = !active;
          field.required = active;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
